<template>
  <div>
    <el-form-item label="图片" v-if="config.image">
      <ImageInput v-model="form.image" :desc.sync="form.imageDesc"></ImageInput>
    </el-form-item>
    <el-form-item label="音频" v-if="config.audio">
      <FileInput v-model="form.audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="文字提示" v-if="config.subject==='tips'">
      <el-input v-model="form.subject"></el-input>
    </el-form-item>
    <el-form-item label="选项" class="exr-items">
      <div class="exr-item-wrap" v-for="(value, key) in form.items" :key="key">
        <div class="exr-item">
          <el-input v-model="value.text" @paste.native.capture.prevent="handlePasteItems($event, key)"></el-input>
          <PinyinInput v-model="value.pinyin" v-if="config.itemsPinyin" :text="value.text" :uppercase="false"></PinyinInput>
          <FileInput v-model="value.audio" v-if="config.itemsAudio" accept="audio/*" tiny></FileInput>
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
        </div>
        <PinyinPreview v-if="config.itemsPinyin" :text="value.text" :pinyin="value.pinyin" popover></PinyinPreview>
      </div>
    </el-form-item>
    <div v-for="(item, key) in selections" :key="key">
      <el-form-item :label="'正确答案' + (key + 1)" class="exr-xctk-answers">
        <cascader placeholder="请选择答案" v-model="item.answer" :items="form.items" :depth="form.items.length" :strictly="config.itemsAlgo"></cascader>
        <el-button type="danger" icon="el-icon-delete" tabindex="-1" @click="removeAnswer(key)"></el-button>
        <el-button icon="el-icon-plus" tabindex="-1" @click="addAnswer(key)"></el-button>
      </el-form-item>
      <el-form-item :label="'答案音频' + (key + 1)" v-if="config.answerAudio">
        <FileInput v-model="item.answerAudio" accept="audio/*"></FileInput>
      </el-form-item>
    </div>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import basexzt from './base-xzt.js'
  import cascader from './cascader'
  import ShowAnswer from "./ShowAnswer"

  export default {
    name: 'PxtForm',
    components: {
      PinyinPreview: require('@/components/PinyinPreview').default,
      PinyinInput: require('@/components/PinyinInput').default,
      FileInput: require('@/components/FileInput').default,
      ImageInput: require('@/components/ImageInput').default,
      cascader,
      ShowAnswer
    },
    mixins: [basexzt],
    data () {
      return {
        selections: [{}],
        formWidth: 0
      }
    },
    mounted () {
      this.formWidth = this.$el.offsetWidth
      this.initFormData(this.form)
    },
    watch: {
      model (val) {
        this.initFormData(val)
      },
      selections () {
        this.form.answers = this.selections
      }
    },
    methods: {
      initFormData (obj) {
        this.selections = obj.answers || [{}]
      },
      addAnswer () {
        this.selections.push({})
      },
      removeAnswer (index) {
        if (this.selections.length <= 1) {
          this.selections.splice(index, 1, {})
        } else {
          this.selections.splice(index, 1)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .exr-items{
    .exr-item{
      display: flex;
      margin-left: -8px;
      > .el-input{
        flex: 1;
        margin-left: 8px;
      }
      > .file-input{
        flex: 1;
        margin-left: 8px;
      }
      > .el-button{
        width: 40px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 8px;
      }
    }
    .exr-item-wrap + .exr-item-wrap{
      margin-top: 12px;
    }
  }
  .exr-answers{
    margin-bottom: 0;
    margin-right: -8px;
  }
  .pxt-selection{
    display: flex;
    margin-bottom: 8px;
    > .el-cascader{
      flex: 1;
    }
    > .el-button{
      margin: 0 8px;
      height: 40px;
    }
  }
</style>
